import { createClient, SupabaseClient } from '@supabase/supabase-js';

import { environment } from '../../../environments/environment';

let client: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient {
  if (client) {
    return client;
  }

  if (!environment.supabaseUrl || !environment.supabaseAnonKey) {
    throw new Error(
      'Missing Supabase config. Set supabaseUrl and supabaseAnonKey in environments.',
    );
  }

  client = createClient(environment.supabaseUrl, environment.supabaseAnonKey, {
    auth: {
      flowType: 'pkce',
      detectSessionInUrl: true,
      persistSession: true,
      autoRefreshToken: true,
    },
  });

  return client;
}

export function oauthRedirectUrl(): string {
  if (environment.oauthRedirectUrl) {
    return environment.oauthRedirectUrl;
  }
  return `${window.location.origin}/auth/callback`;
}
